import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { listArchivedAmericanas, listOpenAmericanas } from "../api/americanas";
import 'font-awesome/css/font-awesome.min.css';
import './AmericanasList.css';
import Dashboard from "./Dashboard";

export default function AmericanasList({ canManage }) {
    const navigate = useNavigate();
    const location = useLocation();
    const successFromState = location.state?.successMessage ?? '';

    const [data, setData] = useState([]);
    const [archived, setArchived] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showArchived, setShowArchived] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(() => successFromState);

    useEffect(() => {
        (async () => {
            try {
                const [openAmericanas, archivedAmericanas] = await Promise.all([
                    listOpenAmericanas(),
                    listArchivedAmericanas()
                ]);
                setData(openAmericanas);
                setArchived(archivedAmericanas);
            } catch (err) {
                setError(err.response?.data?.message || 'No se pudieron cargar las americanas');
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    useEffect(() => {
        if (successFromState) {
            setSuccessMessage(successFromState);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [successFromState, location.pathname, navigate]);

    if (loading) return (
        <div className="americanas-page">
            <div className="loading-state">
                <div className="spinner"></div>
                <p>Cargando eventos...</p>
            </div>
        </div>
    );

    return (
        <div className="americanas-page">

            

            {error && (
                <div className="alert-banner error">
                    <i className="fa fa-exclamation-circle"></i> {error}
                </div>
            )}
            {successMessage && (
                <div className="alert-banner success">
                    <i className="fa fa-check-circle"></i> {successMessage}
                </div>
            )}


            <header className="page-header">
                <h1 className="page-title">Americanas Abiertas</h1>
            </header>

            <div className="cards-grid">

                {canManage && (
                    <div className="event-card create-card" onClick={() => navigate('/americanas/new')}>
                        <div className="create-content">
                            <i className="fa fa-plus-circle create-icon"></i>
                            <span>Crear Nueva Americana</span>
                        </div>
                    </div>
                )}

                {data.length === 0 && !canManage && (
                    <div className="alert-banner info" style={{gridColumn: '1 / -1'}}>
                        No hay americanas abiertas en este momento.
                    </div>
                )}

                {data.map(a => (
                    <div key={a.id} className="event-card" onClick={() => navigate(`/americanas/${a.id}`)}>
                        <div className="card-header">
                            <h3 className="event-name">{a.name}</h3>
                            <div className="event-meta">
                                <div className="meta-row">
                                    <i className="fa fa-calendar"></i>
                                    {new Date(a.dateTime).toLocaleString()}
                                </div>
                                {a.location && (
                                    <div className="meta-row">
                                        <i className="fa fa-map-marker"></i>
                                        {a.location}
                                    </div>
                                )}
                            </div>
                        </div>

                        {a.max != null && (
                            <div className="spots-badge">
                                <i className="fa fa-users" style={{marginRight:'6px'}}></i>
                                Cupo: {a.max}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="archived-section">
                <button
                    className="toggle-archived-btn"
                    onClick={() => setShowArchived(!showArchived)}
                >
                    {showArchived ? <i className="fa fa-chevron-up"></i> : <i className="fa fa-chevron-down"></i>}
                    Ver Americanas Pasadas ({archived.length})
                </button>

                {showArchived && (
                    <div className="archived-list cards-grid">
                        {archived.length === 0 ? (
                            <p className="empty-state">No hay eventos pasados.</p>
                        ) : (
                            archived.map(a => (
                                <div key={a.id} className="event-card" onClick={() => navigate(`/americanas/${a.id}`)}>
                                    <div className="card-header">
                                        <h3 className="event-name">{a.name}</h3>
                                        <div className="event-meta">
                                            <div className="meta-row">
                                                <i className="fa fa-calendar"></i>
                                                {new Date(a.dateTime).toLocaleString()}
                                            </div>
                                            {a.location && (
                                                <div className="meta-row">
                                                    <i className="fa fa-map-marker"></i>
                                                    {a.location}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}